import { defineTokens } from '@chakra-ui/react';

export const fonts = defineTokens.fonts({
	heading: { value: 'var(--acuminVariable), sans-serif' },
	body:    { value: 'var(--acuminVariable), sans-serif' },
});
